import { Checkbox, Divider, Input, Space } from 'antd';
import { useTranslation } from 'react-i18next';

import AntdSelect from '@/components/general/AntdSelect/AntdSelect';
import type CompanyContact from '@/model/General/CompanyContact';

import type { TicketCsatSurveyController } from './useTicketCsatSurvey';

interface TicketCsatSurveyFormProps {
  csat: TicketCsatSurveyController;
}

// Metadata: formulario reusable de la decisión de envío de encuesta CSAT, desacoplado de su Modal.
export const TicketCsatSurveyForm = (props: TicketCsatSurveyFormProps) => {
  const { t } = useTranslation();
  const { csat } = props;
  const formatContactOption = (contact: CompanyContact) => ({
    label: contact.phone ? (
      <>
        {contact.name}
        <Divider type="vertical" /> {contact.phone}
      </>
    ) : (
      contact.name
    ),
    value: contact.id,
  });

  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <Checkbox checked={csat.sendSurvey} onChange={e => csat.setSendSurvey(e.target.checked)}>
        {t('Enviar encuesta de satisfacción al cliente por WhatsApp')}
      </Checkbox>

      {csat.sendSurvey && (
        <>
          <div>
            <p style={{ fontWeight: 500, marginBottom: 8 }}>
              {t('Seleccionar un contacto guardado (opcional)')}
            </p>
            <AntdSelect
              loading={csat.loadingContacts}
              options={csat.contacts.map(formatContactOption)}
              value={csat.contactId}
              onChange={value => csat.setContactId(value as number | undefined)}
              allowClear
              showSearch
              placeholder={t('Sin contacto guardado')}
            />
          </div>

          <div>
            <p style={{ fontWeight: 500, marginBottom: 8 }}>
              {t('Nombre que verá el cliente en la encuesta')}
            </p>
            <Input
              value={csat.name}
              onChange={e => csat.setName(e.target.value)}
              placeholder={t('Nombre')}
            />
          </div>

          <div>
            <p style={{ fontWeight: 500, marginBottom: 8 }}>
              {t('Número de WhatsApp al que se enviará la encuesta')}
            </p>
            <Input
              value={csat.phone}
              onChange={e => csat.setPhone(e.target.value)}
              placeholder={t('Número de teléfono')}
            />
          </div>
        </>
      )}
    </Space>
  );
};
